<template>
  <router-link :to="'/report/' + report.id" class="report link">
    <tr>
      <td data-label="ID" class="w5per">{{ report.id }}</td>
      <td :data-label="translate('reports.name')" class="text-left">{{ report.name }}</td>
      <td :data-label="translate('reports.metric')" class="w15per">{{ report.metric }}</td>
      <td :data-label="translate('reports.status')" class="w15per">{{ translate('reports.statuses.' + report.status) }}</td>
      <td :data-label="translate('reports.client_name')" class="w10per text-left">{{ report.client_name }}</td>
      <td :data-label="translate('reports.owner_user_name')" class="w10per text-left">{{ report.owner_user_name }}</td>
      <td :data-label="translate('reports.created_at')" class="w10per">{{ report.created_at ? get_date(report.created_at) : '' }}</td>
      <td :data-label="translate('reports.started_at')" class="w10per">{{ report.started_at ? get_date(report.started_at) : '' }}</td>
      <td :data-label="translate('reports.finished_at')" class="w10per">{{ report.finished_at ? get_date(report.finished_at) : '' }}</td>
    </tr>
  </router-link>
</template>
<script>
export default {
  name: 'ReportListItem',
  props: { report: { type: Object, required: true } }
}
</script>
<style lang="scss" scoped>
.report {
  color: #252422;
  cursor: pointer;
  tr:hover { background-color: #eee; }
  td { overflow-wrap: anywhere; }
  td.text-left { text-align: left; }
}
</style>
